import styled from '@emotion/styled';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';

export const FlightSearchWrap = styled(ContentWrap)``;
